/** @type {import('../help-index.js').HelpScreen} */
export const HOT_HELP = {
  screenId: 'hot',
  label: 'Hotel — Panel principal',
  navPath: 'Hotel',
  keywords: ['reserva', 'habitación', 'check in', 'check out', 'ocupación', 'huésped'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Panel de ocupación por fecha: reservas, check-in/out del día y acciones sobre cada estancia.',
  sidebarItems: [{
    id: 'hotel-main',
    screenId: 'hot',
    label: 'Panel de hotel',
    description: 'Grilla de habitaciones, llegadas/salidas y operaciones de reserva.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Ves de un vistazo qué habitaciones están libres, reservadas u ocupadas en un rango de fechas. También listás los check-in y check-out del día elegido.',
        },
        {
          title: 'Paso 1 — Elegir la fecha',
          steps: [
            'Arriba a la izquierda, elegí la fecha en el calendario.',
            'Al cambiar la fecha se actualiza la grilla y las listas de entrada y salida.',
          ],
        },
        {
          title: 'Paso 2 — Check-in y check-out del día',
          bullets: [
            'Columna «Check Out»: huéspedes que salen ese día.',
            'Columna «Check In»: llegadas previstas.',
            'Tocá un nombre para abrir la información de la reserva.',
          ],
        },
        {
          title: 'Paso 3 — Grilla de ocupación',
          bullets: [
            'Cada fila es una habitación; las columnas son días.',
            'El color indica el estado (libre, reservado, ocupado, no show, etc.).',
            'Tocá una celda con nombre de huésped para ver detalle y acciones.',
            'Si hay overbooking, se abre una ventana especial para resolver conflictos.',
          ],
        },
        {
          title: 'Paso 4 — Mostrar No Shows',
          paragraphs: [
            'Activá el interruptor «Mostrar No Shows» para incluir reservas marcadas como no show en la grilla.',
          ],
        },
        {
          title: 'Acciones según el estado',
          bullets: [
            'Libre — «Reservar» para crear una nueva reserva en esa habitación y fecha.',
            'Reservado — Cobrar, Modificar, Facturar, Factura T, No Show, Eliminar, Check In.',
            'Ocupado — Cobrar, Modificar, Facturar, Factura T.',
            'No Show — Cobrar, Eliminar reserva, Show Up (si el huésped sí llegó).',
            '«Más información» — detalle ampliado de la estancia.',
          ],
        },
      ],
    },
  }],
}
